"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var e={};exports.__exports=e;
//# sourceMappingURL=react-is.production.js.map
